import styled from "styled-components";
import ThemeColors from "../../../../../../themes/colors";

export const MainContainer = styled.div`
  display: flex;
  padding: 1rem 4rem;
  justify-content: space-between;
  gap: 10rem;
  background-color: ${ThemeColors.Gray500};
  border-radius: 1rem;
  width: fit-content;
  align-self: center;
`;

export const Triangle = styled.div<{ isSelected: boolean }>`
  width: 0;
  height: 0;
  border-left: 1.154rem solid transparent;
  border-right: 1.154rem solid transparent;
  border-bottom: 2rem solid
    ${(props) =>
      props.isSelected ? ThemeColors.Purple500 : ThemeColors.Purple100};
  clip-path: polygon(50% 0%, 100% 100%, 0% 100%);
  border-radius: 0.4rem;
  cursor: pointer;
`;

export const Square = styled.div<{ isSelected: boolean }>`
  width: 2rem;
  height: 2rem;
  background-color: ${(props) =>
    props.isSelected ? ThemeColors.Green500 : ThemeColors.Green100};
  border-radius: 0.4rem;
  cursor: pointer;
`;

export const Circle = styled.div<{ isSelected: boolean }>`
  width: 2rem;
  height: 2rem;
  background-color: ${(props) =>
    props.isSelected ? ThemeColors.Blue500 : ThemeColors.Blue100};
  border-radius: 50%;
  cursor: pointer;
`;
